import { NgModule } from '@angular/core';

import { routing, appRoutingProviders } from './insights.routing.';
import { CommonModule } from '@angular/common';
import { PipesModule } from '../../../pipes/pipes.module';
import { DataTableModule } from '../../data-table/data-table.module';
import { TooltipModule } from '../../tooltip/tooltip.module';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  imports: [
    TooltipModule,
    DataTableModule,
    PipesModule,
    CommonModule,
    SharedModule,
    routing
  ],
  exports: [],
  providers: [appRoutingProviders]
})
export class InsightsModule {}
